module.exports = __webpack_public_path__ + "img/horizontal_3_6_r_pp13_5012.ecfc38c4.png";